<template>
  <div>
    <article
      v-if="this.empresa == '' || this.empresa == undefined"
      class="text-xs-center"
      style="margin: 38px 2px 20px -100px;"
    >
      <svg class="custom_anime" style="width:55px;height:45px" viewBox="0 0 24 24">
        <path
          style="fill: white;"
          d="M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z"
        />
      </svg>
    </article>
    <article v-else style="padding: 40px;">
      <!-- <div class="text-xs-center" id="welcomeMessage"></div> -->
      <fieldset
        class="c_before loading"
        style="padding: 0.35em 0.75em 0.625em;border: 4px solid #ffffffa6;"
      >
        <legend align="center" style="padding: 0px 90px;">
          <div class="periodoBusca">Período de busca:</div>
          <v-layout row wrap class="align-center justify-end row">
            <v-flex xs6 sm2 md2 class="rangeDate" d-flex v-for="(item,i)  in rangeButtons" :key="i">
              <v-btn
                slot="activator"
                color="white"
                text-color="white"
                dark
                round
                :disabled="consultando"
                :class="['d-inline-block' + ' btn_'+item.value, item.selected ? 'teal white--text' : 'v-btn--outline']"
                @click.native="changeSelected(item.value), buscarComRange(item.value)"
              >
                <small>{{item.text}}</small>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout
            v-show="!consultando"
            row
            wrap
            class="align-center justify-center row"
            style="margin-bottom: -28px;"
          >
            <v-flex xs6 sm2 md2 class="reload">
              <v-btn
                style="height: 16px!important;margin-left: -11px;"
                slot="activator"
                outline
                color="white"
                text-color="white"
                dark
                round
                @click.native="refresh()"
                small
              >
                <small>Recarregar</small>
              </v-btn>
            </v-flex>
          </v-layout>
        </legend>
        <v-progress-linear
          color="red"
          style="margin: 0;"
          v-if="activeProgress"
          class="loading_dash_progress"
          :indeterminate="true"
        ></v-progress-linear>
        <v-container fluid grid-list-md id="firstRow">
          <v-layout row wrap class="infos" style="margin-bottom: 31px;">
            <v-flex d-flex xs12 sm3 md3 v-for="(card,i) in cards" :key="card.id">
              <v-card class="cardTipos" :class="card.cor">
                <v-layout row wrap>
                  <v-flex v-if="!changingEmp">
                    <div class="c_title" style>{{card.title}}</div>
                    <div
                      class="values fadeInUp"
                      v-if="!changingEmp"
                      :id="`value${i}`"
                    >{{card.valor}}</div>
                    <div class="analise">{{card.analise}}</div>
                    <img :src="card.path" class="imagem" alt />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex d-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6>
                  <pieChart
                    v-if="!changingEmp"
                    :labels="this.pieSaidaLabels"
                    :data="this.pieSaida"
                    :backgroundColor="this.colorsSaida"
                    :borderColor="this.colorsSaida"
                    :customId="`pieChart2_${this.empresa._id}`"
                    :title="'NF-e de saída por região'"
                    :icon="'place'"
                  ></pieChart>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <pieChart
                    v-if="!changingEmp"
                    :labels="this.pieEntradaLabels"
                    :data="this.pieEntrada"
                    :backgroundColor="this.colorsEntrada"
                    :borderColor="this.colorsEntrada"
                    :customId="`pieChart1_${this.empresa._id}`"
                    :title="'NF-e de entrada por região'"
                    :icon="'place'"
                  ></pieChart>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </fieldset>

      <fieldset
        class="c_before loading"
        style="padding: 0.35em 0.75em 0.625em;border: 4px solid #ffffffa6;margin-top:11px;"
      >
        <legend align="center" style="padding: 0px 90px;">
          <div class="periodoBusca">Período de busca:</div>
          <v-layout row wrap class="align-center justify-end row">
            <v-flex xs6 sm12 md12 d-flex style="color: wheat;">
              {{new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1).toLocaleDateString()}}
              -
              {{new Date().toLocaleDateString()}}
            </v-flex>
          </v-layout>
          <v-layout v-show="!consultando" row wrap class="align-center justify-center row">
            <v-flex xs6 sm2 md2 class="reload">
              <v-btn
                style="height: 16px !important;margin-left: -50%;transform: translateX(-20%);"
                slot="activator"
                outline
                color="white"
                text-color="white"
                dark
                round
                @click.native="refresh()"
                small
              >
                <small>Recarregar</small>
              </v-btn>
            </v-flex>
          </v-layout>
        </legend>
        <v-progress-linear
          color="red"
          style="margin: 0;margin-top: 15px!important;"
          v-if="activeProgress"
          class="loading_dash_progress"
          :indeterminate="true"
        ></v-progress-linear>

        <v-layout row wrap>
          <v-flex d-flex xs12 sm12 md12 style="margin-top: 13px;">
            <barChart
              v-if="!changingEmp"
              :customId="'barChart1'"
              :labels="this.bar1Labels"
              :data="this.bar1Data"
              :title="'Nota Fiscal eletrônica - Quantidade por mês'"
              :icon="'file_copy'"
            ></barChart>
          </v-flex>
        </v-layout>
      </fieldset>
    </article>
  </div>
</template>

<script>
import mapBrasil from "./mapBrasil/MapBrasil.vue";
import pieChart from "./charts/chartPie/ChartPie.vue";
import barChart from "./charts/chartBar/ChatBar.vue";
import DashBoardService from "@/domain/dashboard/DashBoardService";
export default {
  components: {
    pieChart: pieChart,
    mapBrasil: mapBrasil,
    barChart: barChart
  },
  props: ["conta", "empresa", "IBGE", "alert"],
  data: () => ({
    month: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ],
    rangeButtons: [
      {
        text: "7 Dias",
        value: "semana",
        width: "500px",
        noDataText: "nos últimos 7 Dias",
        selected: false,
        show: true
      },
      {
        text: "Mês Atual",
        value: "mesAtual",
        selected: true,
        noDataText: "neste Mês",
        show: true,
        width: "500px"
      },
      {
        text: "Mês anterior",
        selected: false,
        noDataText: "no Mês passado",
        value: "mesAnterior",
        show: true
      }
    ],
    primLoadDash: true,
    colors: ["yellow", "cyan", "blue", "green", "red"],
    pieEntradaLabels: [],
    colorsEntrada: [],
    pieEntrada: [],
    pieSaidaLabels: [],
    pieSaida: [],
    colorsSaida: [],
    consultando: true,
    bar1Data: [
      {
        label: "Total de NF-e entrada",
        data: [],
        backgroundColor: "rgba(255, 0, 0, 0.2)",
        borderColor: "rgba(255, 0, 0, 1)",
        borderWidth: 1
      },
      {
        label: "Total de NF-e saída",
        data: [],
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1
      }
    ],
    bar1Labels: [],
    cards: [
      {
        id: "nfe_Entrada",
        title: "NF-e entrada",
        valor: "",
        analise: "",
        cor: "c_primary",
        path: "static\\img\\file_entrada.png"
      },
      {
        id: "nfe_Saida",
        title: "NF-e saída",
        valor: "",
        analise: "",
        cor: "c_teal",
        path: "static\\img\\file-saida.png"
      },
      {
        id: "nfe_Entrada_canc",
        title: "NF-e entrada canceladas",
        valor: " ",
        analise: "",
        cor: "c_little-grey",
        path: "static\\img\\file-cancel.png"
      },
      {
        id: "nfe_Saida_canc",
        title: "NF-e saída canceladas",
        valor: " ",
        analise: "",
        cor: "c_black",
        path: "static\\img\\file-cancel-saida.png"
      }
    ],
    changingEmp: false,
    activeProgress: false,
    range: "mesAtual"
  }),
  computed: {
    // dashboard() {
    //   return this.$store.state.dashboard;
    // },
  },
  watch: {
    empresa: async function(newV, oldV) {
      if ((oldV != undefined && oldV.hasOwnProperty("_id")) || newV != oldV) {
        if ((newV && oldV && newV._id != oldV._id) || (newV && !oldV)) {
          this.changingEmp = true;
          this.primLoadDash = true;
          await this.getDadosDashBoard(this.range);
          this.changingEmp = false;
        }
      }
    },
    range: async function(newV, oldV) {
      if (newV) {
        this.changeSelected(newV);
        this.changingEmp = true;
        await this.getDadosDashBoard(this.range);
        this.changingEmp = false;
      }
    },
    $route: {
      deep: true,
      handler: function(refreshPage) {}
    }
  },
  methods: {
    refresh: async function() {
      this.changingEmp = true;
      await this.getDadosDashBoard(this.range);
      this.changingEmp = false;
    },
    activeLoader: function() {
      this.activeProgress = true;
      const appDom = document.querySelectorAll(".c_before");
      if (appDom && appDom.length > 0) {
        appDom.forEach(item => {
          item.classList.add("loading");
        });
      }
    },
    desactiveLoader: function() {
      this.activeProgress = false;
      const appDom = document.querySelectorAll(".loading");
      if (appDom && appDom.length > 0) {
        appDom.forEach(item => {
          item.classList.remove("loading");
        });
      }
    },
    logout: function() {
      this.$session.destroy();
      this.$router.push("/");
    },
    animateValue(id, start, end, duration, speed) {
      var range = end - start;
      var current = start;
      var increment = end > start ? speed : 5;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.getElementById(id);
      var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current;
        if (current == end || current >= end) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    resetInfos: async function() {
      this.colorsEntrada = [];
      this.pieEntradaLabels = [];
      this.pieEntrada = [];
      this.pieSaidaLabels = [];
      this.pieSaida = [];
      this.colorsSaida = [];
      this.bar1Data = [
        {
          label: "Total de NF-e entrada",
          data: [],
          backgroundColor: "rgba(255, 0, 0, 0.2)",
          borderColor: "rgba(255, 0, 0, 1)",
          borderWidth: 1
        },
        {
          label: "Total de NF-e saída",
          data: [],
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderColor: "rgba(54, 162, 235, 1)",
          borderWidth: 1
        }
      ];
      // this.bar1Labels = [];
      this.cards = [
        {
          id: "nfe_Entrada",
          title: "NF-e entrada",
          valor: "R$ 0,00",
          analise: "",
          cor: "c_primary",
          path: "static\\img\\file_entrada.png"
        },
        {
          id: "nfe_Saida",
          title: "NF-e saída",
          valor: "R$ 0,00",
          analise: "",
          cor: "c_teal",
          path: "static\\img\\file-saida.png"
        },
        {
          id: "nfe_Entrada_canc",
          title: "NF-e entrada canceladas",
          valor: " ",
          analise: "",
          cor: "c_little-grey",
          path: "static\\img\\file-cancel.png"
        },
        {
          id: "nfe_Saida_canc",
          title: "NF-e saída canceladas",
          valor: " ",
          analise: "",
          cor: "c_black",
          path: "static\\img\\file-cancel-saida.png"
        }
      ];
    },
    getDadosDashBoard: async function(range) {
      if (this.empresa) {
        this.resetInfos();
        this.service = new DashBoardService(this.$http);
        this.activeLoader();
        let i = 0;
        let tipo = "Entrada";
        let dados = {
          qntdNfeCancSaida: 0,
          qntdNfeCancEntrada: 0,
          vlrNfeSaida: 0,
          vlrNfeEntrada: 0,
          top5NfeSaidaRegiao: [],
          top5NfeEntradaRegiao: [],
          periodoNfeSaida: [],
          periodoNfeEntrada: []
        };
        this.consultando = true;
        new Promise(async (resolve, reject) => {
          // if(JSON.stringify(this.dashboard) !== '{}') {
          //   dados = this.dashboard;
          //   resolve(true);
          // }
          await this.service
            .qntNfeEmpresa(this.empresa._id, range)
            .then(async qntdNFe => {
              if (qntdNFe.ok) {
                if (qntdNFe.body.qntd >= 0) {
                  while (i < 2) {
                    await this.service
                      .buscaQntdCancelada(this.empresa.cnpj, tipo, range)
                      .then(resp => {
                        if (resp.ok) {
                          if (resp.body)
                            dados[`qntdNfeCanc${tipo}`] = resp.body.qntd;
                        }
                      });
                    await this.service
                      .buscaVlrTotal(this.empresa.cnpj, tipo, range)
                      .then(resp => {
                        if (resp.ok) {
                          if (resp.body)
                            dados[`vlrNfe${tipo}`] = resp.body.total;
                        }
                      });

                    this.setCard(
                      dados[`vlrNfe${tipo}`],
                      parseInt(dados[`qntdNfeCanc${tipo}`]),
                      tipo
                    );
                    await this.service
                      .buscaTop5(this.empresa.cnpj, tipo, range)
                      .then(resp => {
                        if (resp.ok) {
                          if (resp.body)
                            dados[`top5Nfe${tipo}Regiao`] = resp.body.slice();
                          this.setPieChart(dados[`top5Nfe${tipo}Regiao`], tipo);
                        }
                      });
                    await this.service
                      .buscaPeriodo(this.empresa.cnpj, tipo, "ano")
                      .then(resp => {
                        if (resp.ok) {
                          if (resp.body)
                            dados[`periodoNfe${tipo}`] = resp.body.slice();
                        }
                      })
                      .then(() => {
                        if (i == 1) {
                          this.setBarChart(
                            dados.periodoNfeEntrada,
                            dados.periodoNfeSaida
                          );
                        }
                      });
                    tipo = "Saida";
                    i++;
                    if (i == 2) {
                      resolve(true);
                    }
                  }
                } else {
                  resolve(false);
                }
              } else {
                resolve(false);
              }
            });
        })
          .then(temNota => {
            this.desactiveLoader();
            if (!temNota) {
              let tipo = "Saida";
              this.setCard(
                dados[`vlrNfe${tipo}`],
                parseInt(dados[`qntdNfeCanc${tipo}`]),
                tipo
              );
              this.setPieChart(dados[`top5Nfe${tipo}Regiao`], tipo);
              tipo = "Entrada";
              this.setCard(
                dados[`vlrNfe${tipo}`],
                parseInt(dados[`qntdNfeCanc${tipo}`]),
                tipo
              );
              this.setPieChart(dados[`top5Nfe${tipo}Regiao`], tipo);
              this.setBarChart(dados.periodoNfeEntrada, dados.periodoNfeSaida);
            }
            return temNota;
          })
          .then(temNota => {
            if (
              this.$router.history.current.path == "/DashBoard" &&
              this.range == "mesAtual" &&
              this.primLoadDash == true &&
              !temNota
            ) {
              this.alert.snack.text =
                "Ausência de dados neste mês.\n Para uma nova busca altere o filtro.";
              this.alert.snack.show = true;
              this.alert.snack.time = 5000;
              let auxThis = this;
              // setTimeout(() => {
              //   auxThis.range = "tudo";
              // }, 5000);
            }
          })
          .then(() => {
            setTimeout(() => {
              this.consultando = false;
            }, 800);
            this.primLoadDash = false;
            // this.$store.commit('addDashboard', dados);
          });
      }
    },
    setBarChart(arrayEntrada, arraySaida) {
      new Promise(async (resolve, reject) => {
        let arrayMerged = [];
        arrayMerged = await arrayEntrada.concat(arraySaida).slice();
        await arrayMerged.sort((a, b) => (a.emissao < b.emissao ? -1 : 1));
        resolve(arrayMerged);
      }).then(arrayMerged => {
        this.bar1Labels = [];
        this.bar1Data[0].data = [];
        this.bar1Data[1].data = [];
        let auxThis = this;
        if (arrayMerged) {
          arrayMerged.forEach((item, i) => {
            const objProxItem = {};

            if (item.emissao)
              [item["ano"], item["mes"], item["dia"]] = item.emissao.split("-");
            if (
              arrayMerged[i + 1] != undefined &&
              arrayMerged[i + 1].emissao != undefined
            )
              [
                objProxItem["ano"],
                objProxItem["mes"],
                objProxItem["dia"]
              ] = arrayMerged[i + 1].emissao.split("-");

            const dateItem = new Date(
              `${parseInt(item.ano)}`,
              `${parseInt(item.mes) - 1}`
            );
            const dateProxItem = new Date(
              `${parseInt(objProxItem.ano)}`,
              `${parseInt(objProxItem.mes - 1)}`
            );
            const textBarLabel = `${
              this.month[dateItem.getMonth()]
            } - ${dateItem.getFullYear()}`;

            if (auxThis.bar1Labels.indexOf(textBarLabel) == -1) {
              //se não existe a data na label adicionar ela.
              auxThis.bar1Labels.push(textBarLabel);
              switch (item.tipo) {
                case "Entrada":
                  //se o item for do tipo entrada adicionar qntd no array de Entrada.
                  auxThis.bar1Data[0].data.push(item.qntd.toString());
                  if (
                    dateItem.toLocaleDateString() !=
                    dateProxItem.toLocaleDateString()
                  ) {
                    //verifica se o proximo item é da mesma data, caso não for adicionar 0 ao array de saída
                    auxThis.bar1Data[1].data.push("0");
                  }
                  break;
                case "Saída":
                  //se o item for do tipo Saida adicionar qntd no array de Saida.
                  auxThis.bar1Data[1].data.push(item.qntd.toString());
                  if (
                    dateItem.toLocaleDateString() !=
                    dateProxItem.toLocaleDateString()
                  ) {
                    //verifica se o proximo item é da mesma data, caso não for adicionar 0 ao array de entrada
                    auxThis.bar1Data[0].data.push("0");
                  }
                  break;
              }
            } else {
              if (item.tipo == "Entrada") {
                auxThis.bar1Data[0].data.push(item.qntd.toString());
              } else if (item.tipo == "Saída") {
                auxThis.bar1Data[1].data.push(item.qntd.toString());
              }
            }
          });
        }
      });
    },
    setPieChart(arrayAPI, tipo) {
      if (arrayAPI && arrayAPI.length >= 0) {
        this[`pie${tipo}`] = [];
        this[`pie${tipo}Labels`] = [];
        let auxColors = this.colors.slice();
        this[`colors${tipo}`] = [];
        let auxThis = this;
        arrayAPI.forEach(item => {
          if (item.uf && item.uf != undefined) {
            auxThis[`pie${tipo}`].push(item.qntd);
            let randPos = Math.floor(Math.random() * auxColors.length);
            auxThis[`colors${tipo}`].push(auxColors[randPos]);
            auxColors.splice(randPos, 1);
            auxThis.IBGE.estados.forEach(uf => {
              if (uf.sigla.toLowerCase() == item.uf.toLowerCase()) {
                auxThis[`pie${tipo}Labels`].push(uf.nome);
              }
            });
          }
        });
      }
      //   pieEntrada: [3000, 1200, 100, 33, 55],
      // pieSaidaLabels: ["São Paulo", "Minas Gerais", "Bahia", "Rio de janeiro"],
    },
    setCard: function(vlrTotal, qntdCancelada, tipo) {
      let auxVlrTotal =
        vlrTotal != undefined
          ? vlrTotal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            })
          : "R$ 0,00";
      let auxQntdCancelada = `${
        qntdCancelada && qntdCancelada >= 1
          ? `${qntdCancelada} notas`
          : qntdCancelada == 1
          ? `${qntdCancelada} nota`
          : qntdCancelada == 0
          ? `nenhuma nota`
          : ""
      }`;
      this.cards.find(o =>
        o.id == `nfe_${tipo}` ? (o.valor = auxVlrTotal) : ""
      );
      this.cards.find(o =>
        o.id == `nfe_${tipo}_canc` ? (o.valor = auxQntdCancelada) : ""
      );
    },
    async buscarComRange(periodo) {
      this.range = periodo;
    },
    changeSelected(value) {
      // this.resetSelected();
      // return;
      this.rangeButtons.forEach(item => {
        if (item) {
          if (item.value == value) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        }
      });
    },

    animeValues: function() {
      this.animateValue(
        "value0",
        0,
        document.querySelector("#value0").innerHTML,
        28000,
        20
      );

      this.animateValue(
        "value1",
        0,
        document.querySelector("#value1").innerHTML,
        28000,
        20
      );

      this.animateValue(
        "value2",
        0,
        document.querySelector("#value2").innerHTML,
        28000,
        20
      );

      this.animateValue(
        "value3",
        0,
        document.querySelector("#value3").innerHTML,
        28000,
        20
      );
    },
    setLabelsBar() {
      let ini = new Date();
      let fim = new Date();
      let dataPeriodo;
      switch (this.range) {
        case "semana":
          dataPeriodo = new Date(ini.setDate(ini.getDate() - 7));
          this.bar1Labels = [];
          this.bar1Labels = this.getDiasSemana(dataPeriodo).slice();
          break;
        case "mesAtual":
          dataPeriodo = new Date();
          this.bar1Labels = [];
          this.bar1Labels = this.getDiasMes(
            dataPeriodo.getMonth() + 1,
            dataPeriodo.getFullYear()
          ).slice();
          break;
        case "mesAnterior":
          dataPeriodo = new Date(ini.getFullYear(), ini.getMonth() - 1, 1);
          this.bar1Labels = [];
          this.bar1Labels = this.getDiasMes(
            dataPeriodo.getMonth() + 1,
            dataPeriodo.getFullYear()
          ).slice();
          break;
        default:
          break;
      }
      // new Date(ini.setDate(ini.getDate() - 7));
    },
    getDiasSemana(data) {
      var today = new Date();
      var days = [];
      while (data.getDate() != today.getDate() + 1) {
        days.push(
          data.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit"
          })
        );
        data.setDate(data.getDate() + 1);
      }
      return days;
    },
    getDiasMes(month, year) {
      month--;

      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push(
          date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit"
          })
        );
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
  },
  updated() {},
  mounted: function() {
    this.$nextTick(function() {
      // let auxThis = this;
      return new Promise(async (resolve, reject) => {
        this.activeLoader();
        if (this.empresa.hasOwnProperty("_id")) {
          this.changingEmp = true;
          await this.getDadosDashBoard(this.range);
          this.changingEmp = false;
        } else {
          this.desactiveLoader();
        }
        return resolve();
      }).catch(err => console.log(err));
    });
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
/* ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */
a {
  text-decoration: none;
  color: #42b983;
}
#welcomeMessage {
  background-color: #25476a;
  height: 9em;
}
.c_before {
  position: relative;
}
.periodoBusca {
  color: white;
}
.c_before.loading:after {
  content: "";
  position: absolute;
  width: 98%;
  height: 89.5%;
  background-color: #16123175;
  top: 66px;
  z-index: 5;
  left: 14px;
}
#firstRow {
  margin-top: 0px;
}

.cardTipos {
  border-radius: 8px;
  padding: 33px;
  max-width: 284px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  z-index: 2;
}
.cardTipos.c_primary {
  background: #731d1e;
}
.cardTipos.c_teal {
  background: #2570a2;
}
.cardTipos.c_little-grey {
  background: #abab38;
}
.cardTipos.c_black {
  background: #7d7d7d;
}
.cardTipos .c_icon {
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: 8px;
  font-size: 27px;
}
.cardTipos .values {
  color: white;
  font-size: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
.cardTipos .c_title {
  color: white;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
.cardTipos .analise {
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  font-size: 12px;
}
.cardTipos .imagem {
  position: absolute;
  right: -35px;
  top: -1px;
  z-index: -1;
  overflow: hidden;
  width: 159px;
  opacity: 0.5;
}
@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  animation: fadeInUp 2s ease-in;
}
</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/dashBoard/DashBoard.vue